import dayjs from "dayjs"
import { mapValues, wrapInCurly } from "../utils"

// Add other mapper functions here
export const formatDate = (date: Date) => dayjs(date).format("DD-MM-YYYY")

export const mapperFunctions = {
  formatDate,
}

// Used to reference mappers from flow definitions
export const serializedMappers = mapValues(
  mapperFunctions,
  /*
    Type is set to `any`, to allow for passing values from flow definitions,
    which may be annotated with various types, despite being strings at runtime
  */
  (value, mapperName) => (valueInCurlyBraces?) => {
    const unpackedValue = valueInCurlyBraces?.replaceAll(/\$\{(.*?)\}/gi, "$1")
    return wrapInCurly(`${mapperName}<${unpackedValue}>`)
  },
)
